import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { ReactComponent as Success } from "assets/icons/success.svg";
import { ReactComponent as Ticket } from "assets/icons/ticket.svg";
import { Link } from "react-router-dom";

const Receipt = ({
  button_text: buttonText,
  link,
  title,
  sub_title: subTitle,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col  px-4 py-20  ">
        <div className="w-[90px] h-[90px] table m-auto ">
          <div className="w-[90px] h-[90px] relative flex justify-center items-center p-[14px]">
            <Success className="w-[90px] h-[90px]" />
          </div>
        </div>
        <div className={`text-center text-white h-18px-medium mb-2 pt-4 pb-12`}>
          {t("voucher.submit-successful")}
        </div>
        <div className="bg-white rounded-lg p-3 shadow-xl w-full max-w-96 m-auto">
          <div className="flex items-center justify-center gap-2">
            <Ticket className="[&>path]:fill-primary-0 w-5 h-5  " />
            <div className="body-16px-demibold text-primary-0">{title}</div>
          </div>
          <div className="flex items-center justify-items-start gap-3 my-3 border border-gray--6 p-4 rounded-md ">
            <div className="caption-12px-regular text-gray-0">
              {t("voucher.prize")}
            </div>
            <div className=" bg-gray--7 h-10 w-[1px]" />
            <div className="body-14px-demibold text-gray-4">{subTitle}</div>
          </div>
          <div className="body-14px-regular text-gray-0">{description}</div>
          <Link to={link}>
            <Button
              block
              className={`primary-button-large min-h-[46px] justify-center mt-5 items-center`}
            >
              {buttonText}
            </Button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Receipt;
